// extracted by mini-css-extract-plugin
export default {"main":"cEaTEI","container":"exvndu","mobile":"QYt_I3","title":"bFUAHc","text":"UfEcmB"};